import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import './AtelierInfoSecond.css';

class AtelierInfoSecond extends Component {

  render() {
    const { data, language } = this.props;
    return (
      <div className='AtelierInfoSecond'>
        <div className='AtelierInfoSecond-image' style={{ backgroundImage: `url(${data.photo})` }} />
        <div className='AtelierInfoSecond-content'>
          <p className='LatestDesc--Atelier'>{data.description[language]}</p>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    language: state.language,
  }
}

export default withRouter(
  connect(mapStateToProps)(AtelierInfoSecond)
);


// WEBPACK FOOTER //
// ./src/components/AtelierInfo/AtelierInfoSecond/index.js